import { render, staticRenderFns } from "./StampLoyaltyModal.vue?vue&type=template&id=1e2a8a98&scoped=true&"
import script from "./StampLoyaltyModal.vue?vue&type=script&lang=js&"
export * from "./StampLoyaltyModal.vue?vue&type=script&lang=js&"
import style0 from "./StampLoyaltyModal.vue?vue&type=style&index=0&id=1e2a8a98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a8a98",
  null
  
)

export default component.exports